import { useState, useEffect, useCallback } from 'react'
import { getModels } from '../api'

export function useModelsList() {
  const [models, setModels] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const load = useCallback(() => {
    setLoading(true)
    setError('')
    return getModels()
      .then(setModels)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false))
  }, [])

  /** Обновить список без индикатора загрузки (чтобы UI не мигал) */
  const refresh = useCallback(() => {
    setError('')
    return getModels()
      .then(setModels)
      .catch((e) => setError(e.message))
  }, [])

  useEffect(() => {
    load()
  }, [load])

  return { models, setModels, loading, error, setError, load, refresh }
}
